import { useMemo } from 'react'

import { useVatDeclarations } from '../../../context/vatDeclarationsContext'

export const useHasUnsettledCorrection = (vatDeclarationId: string | undefined) => {
  const { unsettledCorrections } = useVatDeclarations()

  const hasUnsettledCorrection = useMemo(() => {
    if (!vatDeclarationId) {
      return false
    }

    return unsettledCorrections.some((unsettledCorrection) => unsettledCorrection.id === vatDeclarationId)
  }, [unsettledCorrections, vatDeclarationId])

  return { hasUnsettledCorrection }
}
